<template>
    <div class="my-10">
        <h1 class="font-bold text-xl mb-5">{{ $t('page.categories') }}</h1>
        <div class="flex flex-col divide-y">
            <router-link v-for="item in mallCategories" :key="item.id" :to="{ name: 'publications', query: { category: item.id } }"  class="font-semibold text-lg text-gray-700 block  py-4 flex justify-between hover:text-accent-color">{{
              item.name }} <span v-if="item.objects__count > 0" class="text-red-500">{{ item.objects__count }}</span></router-link>
        </div>
    </div>

</template>

<script>

export default {
    name: "mallCategories",
    computed:{
        mallCategories(){
            return this.$store.mallCategories
        }
    }
}

</script>